import React, { useEffect, useState } from 'react';
import { BsBarChartFill } from "react-icons/bs";
import { PiScalesFill } from "react-icons/pi";
import ResetMapToOriginalData from '../../core/resetMapToOriginalData.js';

const ResetLandDataConfirmationModal = ({
    isComparing,
    handleCompareClick,
    mapRef,
    globalRefs,
    globalState
}) => {

    let isResetLandDataConfirmationModalOpen = globalState.isResetLandDataConfirmationModalOpen;
    let setIsResetLandDataConfirmationModalOpen = globalState.setIsResetLandDataConfirmationModalOpen;

    let originalGeoJSONforComparingRef = globalRefs.originalGeoJSONforComparingRef;

    const ResetMapToOriginalDataClick = () => {
        ResetMapToOriginalData(globalRefs, globalState);
        setIsResetLandDataConfirmationModalOpen(false);
    }

    const closeResetMapToOriginalDataClick = () => {
        setIsResetLandDataConfirmationModalOpen(false);
    }

    return (
        <div style={{ position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)', width: '350px', height: '225px', backgroundColor: 'white', zIndex: '1000' }}>
            <div style={{ position: 'absolute', top: '0px', textAlign: 'center', paddingTop: '20px', width: '100%' }}>
                <h2 style={{margin: '0px'}}>Reset</h2>
                <p style={{lineHeight: '20px', marginBottom: '0px', color: 'red'}}>Are you sure you want to reset<br/>the land data?</p>
                <br/>
                <p style={{margin: '0px', color: 'red'}}>This action cannot be undone.</p>
                <div>
                    <button className="closeresetLandDataButton" onClick={closeResetMapToOriginalDataClick}>
                        Close
                    </button>
                    <button className="resetLandDataButtonConfirm" onClick={ResetMapToOriginalDataClick}>
                        Confirm
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ResetLandDataConfirmationModal;